import { render } from "./ProductCardWide.vue?vue&type=template&id=42fad223&scoped=true"
import script from "./ProductCardWide.vue?vue&type=script&lang=js"
export * from "./ProductCardWide.vue?vue&type=script&lang=js"

import "./ProductCardWide.vue?vue&type=style&index=0&id=42fad223&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fad223"]])

export default __exports__